module.exports = __webpack_public_path__ + "static/img/2s-design-b2.a392d0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/2s-design-b2.jpg
// module id = C0Lz
// module chunks = 0